import { AccessDeniedService, PermissionHelperService } from '@core/services';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HasPermissionGuard {
  constructor(
    private accessDeniedService: AccessDeniedService,
    private permissionHelperService: PermissionHelperService,
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const allowed = this.permissionHelperService.hasPermission(route.data['permission']);
    if (!allowed) {
      this.accessDeniedService.navigate();
    }
    return allowed;
  }
}
